var $5693e734f8e52053$exports = {};
const $5693e734f8e52053$var$Configuration = {
    apiUrl: "https://api.hint.com",
    apiVersion: "20260716212633",
    emrNotesUrl: "https://gsvv00p905.execute-api.us-east-1.amazonaws.com/prod",
    emrNotesVersion: undefined,
    emrNotesCsp: "https://gsvv00p905.execute-api.us-east-1.amazonaws.com",
    emrCalendarsUrl: "https://onl8fqxr18.execute-api.us-east-1.amazonaws.com/prod",
    emrCalendarsVersion: undefined,
    emrCalendarsCsp: "https://onl8fqxr18.execute-api.us-east-1.amazonaws.com",
    emrMessagingUrl: "https://uivjk88z7e.execute-api.us-east-1.amazonaws.com/prod",
    emrMessagingVersion: undefined,
    emrMessagingCsp: "https://uivjk88z7e.execute-api.us-east-1.amazonaws.com",
    env: "production",
    hintEnv: "production",
    fullStoryOrgId: "o-1T3FAV-na1",
    googleMapsKey: "AIzaSyC70wIphqbjFg2gjPjkVGEpwym3QTKxSb4",
    googleRecaptchaSiteKey: "6LfOL9gZAAAAADa1ZTyoPjOfwV9pQRXEMhAb9xRM",
    intercomAppId: undefined,
    newRelicAccountId: "1295351",
    newRelicLicenseKey: "f80caba954",
    newRelicApplicationId: "784027700",
    release: "111a62323a479a92e278e0f5564ed0adf03040c9",
    sentryOrganizationId: "o4505133335904256",
    sentryProjectId: "4505286157729792",
    sentryKey: "558356d795f64c16a85cce356d98018c",
    sentryEnvironment: "production",
    sentryReleaseVersion: "111a62323a479a92e278e0f5564ed0adf03040c9",
    stripePublishableKey: "pk_live_ImPWqYGkbMfjwg22MiAmB6u4",
    statuspageEmbedCode: "8mxj6zhmjmzp",
    emrChatAttachmentCsp: "https://*.s3.us-east-1.amazonaws.com"
};
$5693e734f8e52053$exports = $5693e734f8e52053$var$Configuration;


window.CONFIGURATION = $5693e734f8e52053$exports;


//# sourceMappingURL=member-portal-elm.16b77b4b.js.map
